import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const api = {
  get: (url) => axios.get(`${API}/api${url}`, { headers: authHeaders() }).then((r) => r.data),
  post: (url, body) => axios.post(`${API}/api${url}`, body, { headers: authHeaders() }).then((r) => r.data),
  put: (url, body)  => axios.put(`${API}/api${url}`, body, { headers: authHeaders() }).then((r) => r.data),
  patch: (url, body) => axios.patch(`${API}/api${url}`, body, { headers: authHeaders() }).then((r) => r.data),
  del: (url) => axios.delete(`${API}/api${url}`, { headers: authHeaders() }).then((r) => r.data),
};

export const mediaUrl = (path) => (path ? `${API}${path}` : null);

export const errMsg = (e, fallback = "Une erreur est survenue") => e?.response?.data?.detail || e?.message || fallback;

export const triggerDownload = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
};
